export enum ArenaSignAuthenticationTypes {
  Standard = 0,
  SMS = 1
}
